export const formatAuthError = (detail, fallback = "Operazione non riuscita. Riprova.") => {
    if (!detail) return fallback;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((item) => item?.msg || String(item)).join(" ");
    if (typeof detail?.msg === "string") return detail.msg;
    return fallback;
};